import { useMutation, useQueryClient } from "@tanstack/react-query";
import Cookies from "js-cookie";
import { toast } from "sonner";
import { AxiosError } from "axios";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog/dialog";

import { useCancelRequestModal } from "./use-cancel-request-modal";
import { Button } from "@/components/ui/button/button";
import { cancelAllowanceRequest } from "@/config/mutation/employee";

export const CancelAllowanceRequestModal = () => {
  const queryClient = useQueryClient();
  const key = Cookies.get("key") as string;
  const { open, onOpenChange, allowanceId } = useCancelRequestModal();

  const { mutate, isPending } = useMutation({
    mutationFn: cancelAllowanceRequest(key),
  });

  const submitAction = async () => {
    mutate(
      {
        allowanceId,
      },
      {
        onSuccess: async () => {
          // console.log("New Employee", data);
          await queryClient.invalidateQueries({
            queryKey: ["allowances"],
          });
          await queryClient.invalidateQueries({
            queryKey: ["employee", "allowance-requests"],
          });

          toast.success("Allowance Request Cancelled!");
          onOpenChange(false);
        },

        onError: (error) => {
          console.log("ERROR WHILE CANCELING LEAVE REQUEST", error);
          const isAxiosError = error instanceof AxiosError;
          if (isAxiosError) {
            const errorReason = error?.response?.data?.error as string;
            toast.error(errorReason);
          } else {
            toast.error(error?.message);
          }
        },
      }
    );
  };

  return (
    <>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="max-w-xl">
          <DialogHeader>
            <DialogTitle className="tracking-normal">
              Do you want to cancel allowance request?
            </DialogTitle>
          </DialogHeader>

          <div className="flex items-center justify-end">
            <Button onClick={submitAction} disabled={isPending}>
              Continue
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
